<app-introtext>
  <!-- Show different headers based on whether user has already scored points in challenge -->
  <h1 *ngIf="!teamUser || teamUser?.points?.total">
    {{ 'STATS.header' | translate: { prename: user?.firstName, surname: user?.lastName } }}
  </h1>
  <h1 *ngIf="teamUser && !teamUser?.points?.total">
    {{ 'STATS.headerNoPoints' | translate: { prename: user?.firstName, surname: user?.lastName } }}
  </h1>
</app-introtext>

<div *ngIf="!isAchievementsActivated" class="achievement_container">
  <div class="container__item">
    <app-challenge-statistics></app-challenge-statistics>
  </div>
  <div class="wrapper">
    <app-ranking *ngIf="!isMemberInRunningChallenge && !hideCompanyScoreList" class="container__item"></app-ranking>
    <app-achievement-activity *ngIf="!isMemberInRunningChallenge" class="container__item"></app-achievement-activity>
  </div>
</div>

<div *ngIf="isAchievementsActivated" class="achievement_container">
  <div class="container__item">
    <app-challenge-statistics></app-challenge-statistics>
  </div>

  <div class="wrapper">
    <app-achievement></app-achievement>
    <app-ranking *ngIf="!isMemberInRunningChallenge && !hideCompanyScoreList" class="container__item"></app-ranking>
    <app-achievement-activity *ngIf="!isMemberInRunningChallenge" class="container__item"></app-achievement-activity>
  </div>
</div>



// WEBPACK FOOTER //
// /codebuild/output/src3658806670/src/client/web-client/src/app/pages/stats/stats.component.html